
import React, { useMemo, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'

import useTranslation from '../../Hooks/UseTranslation'
import { useProgrammation } from '@/Hooks/UseProgrammation'

import ContentBlock from './components/ContentBlock'
import ArrowDown from '../SvgImages/ArrowDown'
import InputSelect from './components/InputSelect'
import ItemsList from './components/ItemsList'
import { getSelectableGroups } from '../../Helpers/ProgrammationHelper'
import { useDispatch, useSelector } from 'react-redux'
import { updateGroupNameAction, updateGroupParentIdAction } from '../../Redux/Actions/ProgrammationManagerActions'
import { useProject } from '../../Hooks/UseProject'
import InputText from './components/InputText'
import { updateGroupName } from '@/Services/ProgrammationManagerService'
import GroupName from './FormFields/GroupName'

interface Props {
  taskList: any[]
}

const GroupInfo = ({ taskList }: Props) => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { project_id } = useProject()

  const { itemOpened: group, patchItemOpened, errors, setError, unSetError } = useProgrammation()

  const [ parentId, setParentId ] = useState(group?.parentId || '')

  const rootGroups = useMemo(() => {

      return getSelectableGroups(taskList, group._id)
  }, [ taskList, group._id ])

  const handleChangeParentId = (newParentId: string) => {

    setParentId(newParentId)

    dispatch(updateGroupParentIdAction(group._id, newParentId, project_id))
  }

  return (
    <ContentBlock
      title="General"
    >
      <Form onSubmit={(e) => e.preventDefault()}>
        <GroupName />
      <Form.Group>
          <Form.Label>
            {t('PROGRAMMATION_MANAGER:ParentGroupLabel')}
          </Form.Label>
          <Row>
            <Col sm={8}>
              <InputSelect
                value={parentId}
                onChange={handleChangeParentId}
                placeholder={t('PROGRAMMATION_MANAGER:SelectPlaceholder')}
                options={rootGroups}
              />
            </Col>
          </Row>
        </Form.Group>
      </Form>
      <Form onSubmit={(e) => e.preventDefault()}>
        <Form.Group>
          <Form.Label>
            {t('PROGRAMMATION_MANAGER:SubItemsLabel')}
          </Form.Label>
          <ItemsList
            items={group.items}
          />
        </Form.Group>
      </Form>
    </ContentBlock>
  )
}

export default GroupInfo